import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";
import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { ErrorDetails, VehiclesResponse } from "app/services/authentication/connection/interfaces/apiInterfaces";

export class GetVehicleByIdCommand extends IRequestCommand<
  IGetVehicleByIdResponse,
  ErrorDetails,
  IGetVehicleByIdCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'vehicles/{vehicleId}';
  public override setParameters(parameters: IGetVehicleByIdCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{vehicleId}',
      parameters.vehicleId.toString()
    );
  }
}

export interface IGetVehicleByIdCommandParameters extends ICommandParameters {
  vehicleId?: number;
}

export interface IGetVehicleByIdResponse
  extends VehiclesResponse,
    ICommandResponse {}
